import * as React from "react";
import { forwardRef } from "react";
const SvgSelectedBackground = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { opacity: 0.3, cx: 18, cy: 18, r: 18, fill: "#4FA4E7" }), /* @__PURE__ */ React.createElement("circle", { opacity: 0.5, cx: 18, cy: 18, r: 16, fill: "#4FA4E7" }), /* @__PURE__ */ React.createElement("circle", { opacity: 0.7, cx: 18, cy: 18, r: 14, fill: "#4FA4E7" }));
const ForwardRef = forwardRef(SvgSelectedBackground);
export { ForwardRef as ReactComponent };
